import { styled } from 'styled-components';
import { ThemeCard } from '../../theme/components/Card';
import { ThemeHeadline } from '../../theme/components/Headline';
import { theme } from '../../theme/theme';
import { typography } from '../../theme/typography';

export interface KanoBoxProps {
  title: string;
  description: string;
  color: string;
}

export const KanoBox: React.FC<KanoBoxProps> = ({ title, description, color }) => {
  return (
    <Card borderColor={color}>
      <ThemeHeadline title={title} variant='h4' />
      <Description>{description}</Description>
    </Card>
  );
};

const Card = styled(ThemeCard)`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: ${theme.spacing.d};
  text-align: left;

  @media screen and (max-width: ${theme.responsive.breakpoints.medium}) {
    padding: ${theme.spacing.xl} ${theme.spacing.l};
  }
`;

const Description = styled.div`
  ${typography('body1')};
`;
